module.exports = __webpack_public_path__ + "img/60.0572ea81.jpg";